import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/img/logo.png';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

const createWidget = async (logoUrl) => {
  const widgetApiHandler = new ApiStore(WIDGET_API_URL)

  const searchParams = (new URL(document.location)).searchParams;
  const planId = searchParams.get("id");

  const planData = await widgetApiHandler.loadWidgetData(planId);
  const options = {
    ...planData.parsed,
    API_URL: WIDGET_API_URL,
    rotationMode: rotationModes.DEFAULT,
    logo: logo,
    tabs: ['panorama', 'rotation'],
    locale: 'talan_6',
    logoUrl,
  }

  new Widget('#widget', options);
}

createWidget('https://xn--80aacf4bwnk3a.xn--80aa6ajv.xn--p1ai/apartments/flats?area_range={%22min%22:%2238.1%22,%22max%22:%2285.9%22}&complex=2322380&cost_filter=sale,+booked&cost_filter=presale&cost_range={%22min%22:%227301200%22,%22max%22:%2212447900%22}&entrance=1&floor_range={%22min%22:%222%22,%22max%22:%2221%22}&group_layout=false&house=1&hypotec_range={%22min%22:%2229135%22,%22max%22:%2249673%22}&not_first=false&not_last=false&range_type=price');
